import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OAuth2CallbackComponent as OAuth2CallbackReceiver } from './lib/components/oauth2-callback/oauth2-callback.component';
import { SessionSigninComponent as SignInDialog } from './lib/components/session-signin/session-signin.component';
import { SessionSelectorComponent as SessionSelector } from './lib/components/session-selector/session-selector.component';
import { DropdownSessionSelectorComponent as DropdownSessionSelector } from './lib/components/active-session-badge/active-session-badge.component';
import { DefaultSessionsServiceConfigProvider } from './config/sessions.config';
import { SessionsServiceConfigProvider, StorageProvider } from './lib/services/sessions.service';
import { LocalStorageProvider } from './lib/services/storage-providers/local-storage.provider';

@NgModule({
  declarations: [],
  imports: [CommonModule, OAuth2CallbackReceiver, SignInDialog, SessionSelector, DropdownSessionSelector],
  exports: [OAuth2CallbackReceiver, SignInDialog, SessionSelector, DropdownSessionSelector],
  providers: [
    { provide: SessionsServiceConfigProvider, useClass: DefaultSessionsServiceConfigProvider },
    { provide: StorageProvider, useClass: LocalStorageProvider },
  ],
})
export class SessionsModule {}
